import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Helmet from 'react-helmet'

class Preview extends PureComponent {
  static propTypes = {
    mode: PropTypes.string.isRequired,
  }

  render () {
    const { t, mode, match } = this.props
    const url = `${process.env.REACT_APP_API_URL}/templates/${match.params.id}/`
    return (
      <Fragment>
        <Helmet title={`${t('Template')} [${match.params.id}]`} />
        <StyledPreviewFrame className={mode} type="text/html" data={url} />
      </Fragment>
    )
  }
}

export const StyledPreviewFrame = styled.object`
  border-top: 2px solid #86da24;
  transition: all .5s;
  margin: auto;
  display: block;
  height: calc(100vh - 42px);
  width: 100vw;
  box-sizing: border-box;

  &.mobile {
    max-width: 360px;
  }

  &.tablet {
    max-width: 640px;
  }

  &.laptop {
    max-width: 1024px;
  }

  &.desktop {
    max-width: 1366px;
  }

  &.tv {
    width: 100%;
  }
`

export default translate('tr')(Preview)



// WEBPACK FOOTER //
// ./src/pages/Preview/index.jsx